import { render, staticRenderFns } from "./tradebox.vue?vue&type=template&id=36229e3e&scoped=true&"
import script from "./tradebox.vue?vue&type=script&lang=js&"
export * from "./tradebox.vue?vue&type=script&lang=js&"
import style0 from "./tradebox.vue?vue&type=style&index=0&id=36229e3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36229e3e",
  null
  
)

export default component.exports